


























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
// import { Table } from 'element-ui';
@Component({
  name: 'lb-table'
  // components: {
  //   'el-table': Table
  // }
})
export default class extends Vue {
  @Prop({
    default() {
      return [];
    },
  }) private data!: any[];
  @Prop({ type: Boolean, default: false}) private loading!: boolean;
  @Prop() private size!: string;
  @Prop() private width!: string | number;
  @Prop() private height!: string | number;
  @Prop() private maxHeight!: string | number;
  @Prop({ type: Boolean, default: true }) private fit!: boolean;
  @Prop({ type: Boolean, default: false}) private stripe!: boolean;
  @Prop({ type: Boolean, default: false}) private border!: boolean;
  @Prop() private rowKey!: any;
  @Prop() private context!: any;
  @Prop({ type: Boolean, default: true }) private showHeader!: boolean;
  @Prop({ type: Boolean, default: false}) private showSummary!: boolean;
  @Prop({ type: Boolean, default: false}) private sumText!: boolean;
  @Prop() private summaryMethod!: any;
  @Prop() private rowClassName!: any;
  @Prop() private rowStyle!: any;
  @Prop() private cellClassName!: any;
  @Prop() private cellStyle!: any;
  @Prop() private headerRowClassName!: any;
  @Prop() private headerRowStyle!: any;
  @Prop() private headerCellClassName!: any;
  @Prop() private headerCellStyle!: any;
  @Prop({ type: Boolean, default: false}) private highlightCurrentRow!: boolean;
  @Prop() private currentRowKey!: string | number;
  @Prop() private emptyText!: string;
  @Prop() private expandRowKeys!: any[];
  @Prop({ type: Boolean, default: false}) private defaultExpandAll!: boolean;
  @Prop() private defaultSort!: object;
  @Prop() private tooltipEffect!: string;
  @Prop() private spanMethod!: any;
  @Prop({ type: Boolean, default: true }) private selectOnIndeterminate!: boolean;
  @Prop({ default: 16 }) private indent!: number;
  @Prop({
    default() {
      return {
        hasChildren: 'hasChildren',
        children: 'children',
      };
    },
  }) private treeProps!: object;
  @Prop() private lazy!: boolean;
  @Prop() private load!: any;
  @Prop({ type: Boolean }) private exportable!: false;
  @Prop({ type: Boolean }) private filterable!: false;
  @Prop({ type: Boolean }) private addable!: false;
  @Prop({ type: Boolean }) private addDisable!: false;

  private showSelection: boolean = false;
  private multipleSelection: any[] = [];

  private handleFilter(obj: object) {
    this.$emit('filter', obj);
  }
  private beginExport() {
    this.showSelection = true;
  }
  private doAdd() {
    this.cancelExport();
    this.$emit('add');
  }
  private resetTableNav() {
    // @ts-ignore
    this.$refs.tableNav.reset();
  }
  private doExport() {
    this.$emit('export', this.multipleSelection);
    // @ts-ignore
    this.$refs.lbTable.clearSelection();
    this.multipleSelection = [];
    this.showSelection = false;
  }
  private cancelExport() {
    // @ts-ignore
    this.$refs.lbTable.clearSelection();
    this.multipleSelection = [];
    this.showSelection = false;
  }
  private handleSelectionChange(val: any[]) {
    this.multipleSelection = val;
    this.$emit('selection-change',val);
  }
  private handleCellMouseEnter(row: any, column: any, cell: any, event: any) {
    this.$emit('cell-mouse-enter', row, column, cell, event);
  }
  private handleCellMouseLeave(row: any, column: any, cell: any, event: any) {
    this.$emit('cell-mouse-leave', row, column, cell, event);
  }
  private handleCellClick(row: any, column: any, cell: any, event: any) {
    this.$emit('cell-click', row, column, cell, event);
  }
  private handleCellDblClick(row: any, column: any, cell: any, event: any) {
    this.$emit('cell-dblclick', row, column, cell, event);
  }
  private handleRowClick(row: any, column: any, event: any) {
    this.$emit('row-click', row, column, event);
  }
  private handleRowContextMenu(row: any, column: any, event: any) {
    this.$emit('row-contextmenu', row, column, event);
  }
  private handleRowDblClick(row: any, column: any, event: any) {
    this.$emit('row-dblclick', row, column, event);
  }
  private handleHeaderClick(column: any, event: any) {
    this.$emit('header-click', column, event);
  }
  private handleHeaderContextMenu(column: any, event: any) {
    this.$emit('header-contextmenu', column, event);
  }
  private handleSortChange({ column, prop, order }: any) {
    this.$emit('sort-change', column, prop, order);
  }
  private handleFilterChange(filters: any) {
    this.$emit('filter-change', filters);
  }
  private handleCurrentChange(currentRow: any, oldCurrentRow: any) {
    this.$emit('current-change', currentRow, oldCurrentRow);
  }
  private toggleAllSelection() {
    // @ts-ignore
    this.$refs.lbTable.toggleAllSelection();
  }
  private clearSelection() {
    // @ts-ignore
    this.$refs.lbTable.clearSelection();
  }
  private toggleRowSelection(row: any, selected: any) {
    // @ts-ignore
    this.$refs.lbTable.toggleRowSelection(row, selected);
  }
  private toggleRowExpansion(row: any, expanded: any) {
    // @ts-ignore
    this.$refs.lbTable.toggleRowExpansion(row, expanded);
  }
  private setCurrentRow(row: any) {
    // @ts-ignore
    this.$refs.lbTable.setCurrentRow(row);
  }
  private clearSort() {
    // @ts-ignore
    this.$refs.lbTable.clearSort();
  }
  private clearFilter() {
    // @ts-ignore
    this.$refs.lbTable.clearFilter();
  }
  private doLayout() {
    // @ts-ignore
    this.$refs.lbTable.doLayout();
  }
}
